function estimateEditSize(edit) {
    const jsonOverhead = 250;
    const contentSize = edit.filename.length * 2 + edit.oldCode.length + edit.newCode.length;
    return jsonOverhead + contentSize;
}
function groupEditsByFile(edits) {
    const groups = new Map();
    for (const edit of edits) {
        const fileEdits = groups.get(edit.filename) || [];
        fileEdits.push(edit);
        groups.set(edit.filename, fileEdits);
    }
    return groups;
}
export function chunkChangeModeEdits(edits, maxCharsPerChunk = 20000) {
    if (edits.length === 0) {
        return [];
    }
    const chunks = [];
    const fileGroups = groupEditsByFile(edits);
    let currentChunk = [];
    let currentSize = 0;
    for (const [_filename, fileEdits] of fileGroups) {
        const fileSize = fileEdits.reduce((sum, edit) => sum + estimateEditSize(edit), 0);
        if (fileSize > maxCharsPerChunk) {
            if (currentChunk.length > 0) {
                chunks.push(createChunk(currentChunk, chunks.length + 1, currentSize));
                currentChunk = [];
                currentSize = 0;
            }
            for (const edit of fileEdits) {
                const editSize = estimateEditSize(edit);
                if (currentSize + editSize > maxCharsPerChunk && currentChunk.length > 0) {
                    chunks.push(createChunk(currentChunk, chunks.length + 1, currentSize));
                    currentChunk = [];
                    currentSize = 0;
                }
                currentChunk.push(edit);
                currentSize += editSize;
            }
        }
        else {
            if (currentSize + fileSize > maxCharsPerChunk && currentChunk.length > 0) {
                chunks.push(createChunk(currentChunk, chunks.length + 1, currentSize));
                currentChunk = [];
                currentSize = 0;
            }
            currentChunk.push(...fileEdits);
            currentSize += fileSize;
        }
    }
    if (currentChunk.length > 0) {
        chunks.push(createChunk(currentChunk, chunks.length + 1, currentSize));
    }
    const totalChunks = chunks.length;
    return chunks.map((chunk, index) => ({
        ...chunk,
        totalChunks,
        hasMore: index < totalChunks - 1,
    }));
}
function createChunk(edits, chunkIndex, estimatedChars) {
    return {
        edits,
        chunkIndex,
        totalChunks: 0,
        hasMore: false,
        estimatedChars,
    };
}
//# sourceMappingURL=changeModeChunker.js.map